import "D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\core-js\\modules\\es6.promise.js";
import "D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from "vue";
import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import echarts from "echarts";
import "@/styles/index.scss"; // global css

import App from "./App";
import store from "./store";
import router from "./router";
import "@/icons"; // icon
import "@/permission"; // permission control
import VueSignaturePad from "vue-signature-pad";
Vue.prototype.$echarts = echarts;
Vue.prototype.$tableHeaderColor = "rgba(247, 248, 250)";
Vue.prototype.$tablePageSizes = [5, 10, 20, 50, 100, 200, 500];
// set ElementUI lang to EN
Vue.use(ElementUI, {
  zhLocale: zhLocale
});
Vue.use(VueSignaturePad);
// 使用全局权限指令
import permission from "@/directive/permission/index.js"; // 权限判断指令
Vue.use(permission);
Vue.config.productionTip = false;
new Vue({
  el: "#app",
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});